export const API_BASE = window.location.origin;

export interface CountrySupportInfo {
  email: string;
  provideUserData?: string;
  handleUserData?:string;
  phone?: string;
}

export const countrySupportMap: Record<string, CountrySupportInfo> = {
  AU: {
    email: "SmartDriveAction_AU@permobil.com ",
    provideUserData: "/files/AU-Provide-User-Data.xlsx",
    handleUserData:"/files/AU-Handle-User-Data.xlsx",
    phone: "1300 845 483",
  },
  NZ: {
    email: "SmartDriveAction_NZ@permobil.com",
    // provideUserData: "/files/NZ-support.pdf",
    // handleUserData:"/files/ADM-Handle-User-Data.xlsx",
    phone: "0800 115 222",
  },
  JP: {
    email: "SmartDriveAction_JP@permobil.com",
    provideUserData: "/files/JP-Provide-User-Data.xlsx",
    handleUserData:"/files/JP-Handle-User-Data.xlsx",
    phone: "03 6659 9500",
  },
  KR: {
    email: "SmartDriveAction_KR@permobil.com",
    // provideUserData: "/files/KR-support.pdf",
    handleUserData:"/files/KR-Handle-User-Data.xlsx",
    phone: "02 566 2020",
  },
  TW: {
    email: "SmartDriveAction_ADM@permobil.com",
    // provideUserData:"/files/AU-Handle-User-Data.xlsx",
    handleUserData: "/files/ADM-Handle-User-Data.xlsx",
    // phone: "123-736-4567",
  },
  HK: {
    email: "SmartDriveAction_ADM@permobil.com",
    // provideUserData:"/files/AU-Handle-User-Data.xlsx",
    handleUserData: "/files/ADM-Handle-User-Data.xlsx",
    // phone: "123-736-4567",
  },
  SG: {
    email: "SmartDriveAction_ADM@permobil.com",
    // provideUserData:"/files/AU-Handle-User-Data.xlsx",
    handleUserData: "/files/ADM-Handle-User-Data.xlsx",
    // phone: "123-736-4567",
  },
  // CN: {
  //   email: "SmartDriveAction_ADM@permobil.com",
  //   provideUserData:"/files/AU-Handle-User-Data.xlsx",
  //   handleUserData: "/files/ADM-Handle-User-Data.xlsx",
  //   phone: "123-736-4567",
  // },
  Hant: {
    email: "SmartDriveAction_ADM@permobil.com",
    // provideUserData:"/files/AU-Handle-User-Data.xlsx",
    handleUserData: "/files/ADM-Handle-User-Data.xlsx",
    //  phone: "123-736-4567",
  },
  // AMER
 US: {
    email: "SmartDriveAction_AMER@permobil.com",
    provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/AMER-Handle-User-Data.xlsx",
    phone: "800-736-0925",
  },
  CA: {
    email: "SmartDriveAction_AMER@permobil.com",
    provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/AMER-Handle-User-Data.xlsx",
    phone: "800-736-0925",
  },
  //EMEA
  BE:{
    email: "SmartDriveAction_BE@permobil.com",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/BE-Handle-User-Data.xlsx",
    phone: "+31 (0)85 808 54 00",
  },
   CH:{
    email: "SmartDriveAction_CH@permobil.com",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/CH-Handle-User-Data.xlsx",
    phone: "+41 41 672 76 00",
  },
   DE:{
    email: "SmartDriveAction_DE@permobil.com",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/DE-Handle-User-Data.xlsx",
    phone: "+49 2102 94 34 00",
  },
   DK:{
    email: "SmartDriveAction_DK@permobil.com",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/DK-Handle-User-Data.xlsx",
    phone: "+45 44681406",
  },
   ES:{
    email: "SmartDriveAction_ES@permobil.com",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/ES-Handle-User-Data.xlsx",
    phone: "670.227.331 0",
  },
   FR:{
    email: "SmartDriveAction_FR@permobil.com",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/FR-Handle-User-Data.xlsx",
    phone: "01 73 09 12 34",
  },
   UK:{
    email: "SmartDriveAction_UK@permobil.com",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/UK-Handle-User-Data.xlsx",
    phone: "01484 722 888",
  },
  IT:{
    email: "SmartDriveAction_IT@permobil.com",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    // handleUserData: "/files/AMER_Handle-User-Data.xlsx",
    phone: "+39 0422 484657",
  },
  NL:{
    email: "SmartDriveAction_NL@permobil.com",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/IT-Handle-User-Data.xlsx",
    phone: "+31 (0)85 808 54 00",
  },
  NO:{
    email: "SmartDriveAction_NO@permobil.com ",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/NO-Handle-User-Data.xlsx",
    phone: "+47 9024 5555",
  },
  SE:{
    email: "SmartDriveAction_SE@permobil.com",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/SE-Handle-User-Data.xlsx",
    phone: "08-761 50 40",
  },
  GL:{
     email: "SmartDriveAction_DIST@permobil.com",
    // provideUserData: "/files/AMER-Provide-User-Data.xlsx",
    handleUserData: "/files/DIST-Handle-User-Data.xlsx",
    phone: "+46 60 787 90 60",
  }
};